export const siteSettings = {
  name: "Apex Trade Solutions",
  link: "https://apexsolution.live",
  email: "support@apexsolution.live",
  appLink: "https://app.apexsolution.live",
};
